import { CmpCheck, loadScript } from "./utils";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	const checkCmp = new CmpCheck();
	checkCmp.checkConsent().then((response) => {
		if (response === false) return;
		// console.log("CMP consent response:", response);
		const FBjsonConfig = document.querySelector("script#fb-app-config");
		if (FBjsonConfig) {
			try {
				const fbConfig = JSON.parse(FBjsonConfig.textContent);
				loadScript(
					"facebook-jssdk",
					`https://connect.facebook.net/${fbConfig.language}/sdk.js`,
				).then((result) => {
					// initialize the library with the API key
					window.fbAsyncInit = () => {
						FB.init({
							appId: fbConfig.appId,
							xfbml: false,
							version: `v${fbConfig.apiVersion}`,
							cookie: true,
						});
					};
					const FBReady = new Event("FBReady");
					document.dispatchEvent(FBReady);
				});
			} catch (error) {
				this.debug.error("Failed to parse FB JSON config:", error);
			}
		}
	});
});
